export const cilBolt = ["24 24","<path d='M15.537 9l3.609-8.25h-12.215l-3.797 13.5h5.673l-1.853 9h2.759l12.574-14.25zM9.037 21.75h-0.241l1.853-9h-5.533l2.953-10.5h8.785l-3.609 8.25h5.719z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-bolt.js
// module id = null
// module chunks = 